import { useMutation } from '@tanstack/react-query';
import { getProjectByID } from "@/api/project"; 
import { GetDeleteProjectData,Project } from "@/types/project"; 
import { PostParam } from "@/types/index"; 

export function useGetProject(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<Project, Error, GetDeleteProjectData>({
    mutationFn: getProjectByID,
    onSuccess,
    onError
  });
}
